<template>
  <v-container fluid class="salescost-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" sm="12" md="12" lg="12" class="d-flex flex-start justify-md-start overflow-auto">
              <v-btn color="success" class="button-shadow mr-2" @click="makeCostList">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Add
              </v-btn>
              <v-btn color="success" class="button-shadow mr-2" @click="runCostDialog">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Run
              </v-btn>
              <v-btn color="success" class="button-shadow mr-2" @click="isFindDialog=true">
                <v-icon class="mr-2">mdi-file-search</v-icon>
                Find
              </v-btn>

              <v-btn to="/salesorder/list" color="default" class="button-shadow mr-3">
                <v-icon class="mr-2">mdi-file-multiple</v-icon>
                Orders
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              show-select
              item-key="_id"
              v-model="data_select"
              loading-text="Loading... Please wait"
              class="salescosts-table"
              :loading="isReceiving || isDeleting"
              :footer-props="footer"
              :headers="headers"
              :items="data_orders"
              :items-per-page="num_items">
              <template v-slot:top>
                <v-dialog
                  v-model="isDeleteCost"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this Cost?
                    </v-card-title>
                    <v-card-text>
                      {{ delete_cost.salesordernum }} 
                      {{ delete_cost.salesordername }}
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="isDeleteCost = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deleteCost(delete_cost)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.userid="{ item }">
                <div v-if="item.userid!=undefined">
                  <p class="two-line" style="margin-left: 0px;">
                    <v-avatar v-if="item.userid!=null && users.length>0" size="40">
                      <img v-bind:src="users.find(user=>user._id == item.userid)['userimage']" alt="">
                    </v-avatar>
                    <v-avatar
                      v-else
                      color="warning"
                      size="40">
                      <p class="two-line"><span class="white--text headline">{{ item.userid!=null && users.length>0 ? users.find(user=>user._id == item.driverid)['username'][0].toUpperCase() : '' }}</span></p>
                    </v-avatar>
                </p>
                <p class="two-line"><span style="margin-left:0px; font-size: 9pt;">{{ item.userid!=null && users.length>0 ? users.find(user=>user._id == item.userid)['username'] : '' }} </span></p>
                </div>
              </template>
              <template v-slot:item.salesorderimage="{ item }">
                    <v-img
                    v-if="item.salesorderimage" 
                    v-bind:src="item.salesorderimage"
                    max-height="60"
                    max-width="60"
                  ></v-img>
              </template>
              <template v-slot:item.isCost="{ item }">
                <v-icon v-if="item.isCost==true" size="18" color="blue">mdi-check</v-icon>
              </template>
              <template v-slot:item.deposits="{ item }">
                <div v-if="item.deposits" style="font-size: 10pt;">{{ item.deposits.map(item=>new Date(item.transdate).toLocaleString("en-SG", { year: '2-digit', month: '2-digit', day: 'numeric' }) + ':&nbsp;&nbsp;' + `$${item.transamount.toFixed(2)}`).join('\n') }}</div>
              </template>
              <template v-slot:item.salesordernum="{ item }">
                <div v-if="item.salesordernum">
                  <p class="two-line">{{ item.salesordertype  }}</p>
                  <p class="two-line">{{ item.salesordernum  }}</p>
                  <p v-if="item.salesorderdate!=null" class="two-line">{{ new Date(item.salesorderdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' })  }}</p>
                  <p v-if="item.salesorderdate!=item.salesorderpostdate" class="two-line"><b>Post: {{ new Date(item.salesorderpostdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' })  }}</b></p>
                  <p v-if="item.salesordertype=='Credit Order'" class="two-line"><b>Due: {{ new Date(item.salesorderduedate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' })  }}</b></p>
                </div>
              </template>
              
              <template v-slot:item.salesordername="{ item }">
                <div v-if="item.salesordername">
                  <p class="two-line" style="font-size: 10pt;">{{ item.salesordername }}</p>
                <p class="two-line" style="font-size: 10pt;">{{ item.salesorderaddress }}</p>
                <p class="two-line" v-if="item.locationid!=undefined">
                  <span v-if="item.locationid && locations.find(location=>location._id == item.locationid)!=null">{{ locations.length>0 ? locations.find(location=>location._id == item.locationid)['locationcode'] : ''  }}&nbsp;-&nbsp;</span> 
                  <span v-if="item.channelid">{{ saleschannels.length>0 ? saleschannels.find(channel=>channel._id == item.channelid)['channelcode'] : ''  }}</span>
                </p>
                </div>

              </template>
              <template v-slot:item.order_sum="{ item }">
                <p class="two-line">{{ item.order_sum.toFixed(2) }}</p>
              </template>
              <template v-slot:item.cost_sum="{ item }">
                <p class="two-line">{{ item.cost_sum.toFixed(2) }}</p>
              </template>
              <template v-slot:item.margin="{ item }">
                <p v-if="item.margin" class="two-line">{{ item.margin.toFixed(2) }}</p>
              </template>
              <template v-slot:item.salesorderstatus="{ item }">
                <v-chip
                  v-if="item.salesorderstatus!=undefined"
                  :color="getStatusColor(item.salesorderstatus)" 
                  small>
                  {{ item.salesorderstatus }}
                </v-chip>
              </template>
              <template v-slot:item.createdAt="{ item }">
                <div>
                  {{ new Date(item.createdAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
                </div>
              </template>
              <template v-slot:item.actions="{ item }">
                <div v-if="item._id!=undefined">
                <v-btn icon color="primary" @click="viewItem(item)">
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
                <v-btn v-if="item.isCost==true" icon color="primary" @click="deleteCostDialog(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
                </div>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
    <v-dialog
      v-model="isFindDialog"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Find Sales Orders</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-select
                  :items="locations.filter(x=>x.locationstatus=='Active').map(x => {
                            return {text: x.locationname, value: x._id};
                          })"
                  v-model="find_query.locationid"
                  label="Location"
                  required
                  dense
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-select
                  :items="users.filter(x=>x.userstatus=='Active').map(x => {
                            return {text: x.username, value: x._id};
                          })"
                  v-model="find_query.userid"
                  label="Sales Rep"
                  required
                  dense
                ></v-select>
              </v-col>
              <v-col cols="12" sm="4" md="4">
                <v-select
                  :items="['Cash Order', 'Credit Order', 'Pre Order', 'Sales Order']"
                  v-model="find_query.ordertype"
                  label="Order Type"
                  required
                  dense
                ></v-select>
              </v-col>
              <v-col cols="12" sm="4" md="4">
                <v-select
                  :items="['New', 'Credit', 'Pending', 'Partial', 'Completed', 'Audit', 'Void']"
                  v-model="find_query.orderstatus"
                  label="Order Status"
                  required
                  dense
                ></v-select>
              </v-col>
              <v-col cols="12" sm="4" md="4">
                <v-text-field
                  class="mb-4"
                  type="number"
                  placeholder="Order Num"
                  v-model="find_query.ordernum"
                  dense
                  oninput="if(this.value < 1) this.value = 1;"
                  single-line hint="Order Num">
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                        <v-menu
                          ref="menu_startdate"
                          v-model="menu_startdate"
                          :close-on-content-click="false"
                          :return-value.sync="find_query.startdate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              dense
                              v-model="find_query.startdate"
                              v-on:change="onChangeFindStartDate($event)"
                              label="Start Date"
                              v-bind="attrs"
                              v-bind:value="find_query.startdate"
                              v-on="on"
                              persistent-hint
                              single-line hint="Please enter start date">
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="find_query.startdate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_startdate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="onChangeFindStartDate(find_query.startdate); $refs.menu_startdate.save(find_query.startdate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                        <v-menu
                          ref="menu_enddate"
                          v-model="menu_enddate"
                          :close-on-content-click="false"
                          :return-value.sync="find_query.enddate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              dense
                              v-model="find_query.enddate"
                              label="End Date"
                              v-bind="attrs"
                              v-bind:value="find_query.enddate"
                              v-on="on"
                              persistent-hint
                              single-line hint="Please enter end date">
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="find_query.enddate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_enddate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu_enddate.save(find_query.enddate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="isFindDialog = false"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="resetSalesOrders"
          >
            Reset
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="findSalesCosts"
          >
            Find
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
  <div class="text-center">
    <v-dialog
        v-model="isConfirmCost"
        persistent
        width="400px"
        max-width="800px"
      >
          <v-card>
            <v-card-title>
              <span class="text-h5">Confirm Costing</span>
            </v-card-title>
            <v-card-text>
              Number of Orders: {{ confirm_cost.num_orders }} 
            </v-card-text>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" md="12">
                    <v-text-field
                      v-model="confirm_cost.confirm"
                      required
                      dense
                      persistent-hint
                      single-line hint="Type the word 'Confirm'"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="isConfirmCost=false; confirm_cost={}"
              >
                Close
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                :disabled="confirm_cost.confirm!=='Confirm'"
                @click="updateOrderCost"
              >
                Confirm
              </v-btn>
            </v-card-actions>
          </v-card>
      </v-dialog>
      <v-dialog
        v-model="isRunCost"
        persistent
        width="400px"
        max-width="400px"
        >
        <v-card>
          <v-card-title>
            <span class="text-h5">Run Costs</span>
          </v-card-title>
            <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="12">
                  <v-menu
                    ref="run_startdate"
                    v-model="run_startdate"
                    :close-on-content-click="false"
                    :return-value.sync="run_cost.startdate"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        dense
                        v-model="run_cost.startdate"
                        v-on:change="onChangeStartDate($event)"
                        label="Start Date"
                        v-bind="attrs"
                        v-bind:value="run_cost.startdate"
                        v-on="on"
                        single-line hint="Please choose the start date">
                      </v-text-field>
                    </template>
                    <v-date-picker
                      v-model="run_cost.startdate"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="run_startdate = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="onChangeStartDate(run_cost.startdate); $refs.run_startdate.save(run_cost.startdate)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="12">
                  <v-menu
                    ref="run_enddate"
                    v-model="run_enddate"
                    :close-on-content-click="false"
                    :return-value.sync="run_cost.enddate"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        dense
                        v-model="run_cost.enddate"
                        label="End Date"
                        v-bind="attrs"
                        v-bind:value="run_cost.enddate"
                        v-on="on"
                        single-line hint="Please choose the end date">
                      </v-text-field>
                    </template>
                    <v-date-picker
                      v-model="run_cost.enddate"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="run_enddate = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.run_enddate.save(run_cost.enddate)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="isRunCost = false"
              >
                Close
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                @click="runOrderCosts"
              >
                Save
              </v-btn>
            </v-card-actions>
          
        </v-card>
      </v-dialog>
      <v-dialog
      v-model="dialogAlert"
      width="300"
    >
      <v-card>
        <v-card-title class="text-h5 lighten-2">Error</v-card-title>
        <v-card-text>
          {{ dialogMessage }}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="dialogAlert = false"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
  </v-container>
</template>

<script>
import config from "../../../config"
import { mapState, mapActions } from 'vuex'
import { getStatusColor, getLastDay } from '@/util/tools';

export default {
  name: 'SalesOrderList',
  data() {
    return {
      config,      
      isDeleteCost: false,
      dialogAlert: false,
      dialogMessage: '',
      isFindDialog: false,
      isConfirmCost: false,
      isRunCost: false,
      menu_startdate: null,
      menu_enddate: null,
      run_startdate: null,
      run_enddate: null,
      num_items: 500,
      delete_cost: {},
      find_query: {},
      confirm_cost: {},
      run_cost: {},
      footer: {'items-per-page-options': [500, 1000, 5000]},
      headers: [
        { text: 'Image', value: 'salesorderimage', sortable: false, width: "5%"  },
        { text: 'Order', value: 'salesordernum', sortable: false, width: "15%" },
        { text: 'Name', value: 'salesordername' },
        { text: 'Amount', value: 'order_sum', width: "8%" },
        { text: 'Cost', value: 'cost_sum', width: "8%" },
        { text: 'Margin', value: 'margin', width: "8%" },
        { text: 'Status', value: 'salesorderstatus', width: "8%"  },
        { text: 'Cost', value: 'isCost', width: "5%" },
        { text: 'Actions', value: 'actions', sortable: false, width: "8%"  },
      ],
      data_orders: [],
      data_select: [],
      getStatusColor: getStatusColor,
    }
  },
  computed: {
    ...mapState('SalesCost', ['salescosts', 'isReceiving', 'isDeleting']),
    ...mapState('Location', ['locations']),
    ...mapState('SalesChannel', ['saleschannels']),
    ...mapState('User', ['users']),
  },
  methods: {
    ...mapActions('SalesCost', ["getSalesCostsRequest", "findSalesCostsRequest", "deleteSalesCostsRequest", "runSalesCostRequest","updateSalesCostRequest"]),
    ...mapActions('Location', ["getLocationsRequest"]),
    ...mapActions('SalesChannel', ["getSalesChannelsRequest"]),
    ...mapActions('User', ["getUsersRequest"]),
    getJson(){
      let json = this.data_orders.map(order=>{return {
        ordernum: order.salesordernum, 
        orderdate: order.salesorderdate!=undefined ? new Date(order.salesorderdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) : '',
        ordertime: order.salesorderdate!=undefined ? new Date(order.salesorderdate).toLocaleString("en-SG", { hour: 'numeric', minute: 'numeric' }) : '',
        ordertype: order.salesordertype,
        customer_name: order.salesordername, 
        customer_address: order.salesorderaddress,
        customertype: order.customertype,
        location: order.locationid!=null && this.locations.find(location=>location._id == order.locationid)!=null && this.locations.length>0 ? this.locations.find(location=>location._id == order.locationid)['locationname'] : '',
        channel: order.channelid!=null && this.saleschannels.length>0 ? this.saleschannels.find(channel=>channel._id == order.channelid)['channelname'] : '',
        salesrep: order.userid!=null && this.users.length>0 ? this.users.find(user=>user._id == order.userid)['username'] : '',
        status: order.salesorderstatus,
        tax: order.salesordertaxamount,
        subtotal: order.salesordersubtotal,
        total: order.salesordertotal,
        rate: order.currencyRate,
      }});
      return json;
    },
    checkError(){
      if(this.data_select.length==0) return false;
      if(this.data_select.find(item=>item.salesorderstatus!='Completed' || item.isCost==true) !=null ) return false;
      return true;
    },
    checkSalesOrders(){
      return this.data_select.filter(item=>item.salesorderstatus!='Completed' || item.isCost==true).map(item=>item.salesordernum.toString()).join(', ');
    },
    getFileName(){
      var d = new Date();
      var name = 'sales-costs-' + d.getFullYear() + '-' + (d.getMonth()+1).toString() + '-' + d.getDate() + '-' + (d.getHours().toString() +d.getSeconds().toString());
      return name + '.csv';
    },
    onChangeStartDate(value) {
      let date = new Date(value);
      let end_date = getLastDay(date);
      this.run_cost = Object.assign({}, this.run_cost, {enddate: end_date});
    },
    onChangeFindStartDate(value) {
      let date = new Date(value);
      let end_date = getLastDay(date);
      this.find_query = Object.assign({}, this.find_query, {enddate: end_date});
    },
    makeCostList(){
      if(!this.checkError()) {
        if(this.data_select.length==0) this.dialogMessage='No Orders selected';
        else this.dialogMessage='The following Orders cannot perform costing:  ' + this.checkSalesOrders();
        this.dialogAlert=true; 
        return;
      }
      let orders = Object.assign([], this.data_select.map(i=>i._id));
      let json = {orders: orders, num_orders: orders.length};
      this.confirm_cost = json;
      this.isConfirmCost = true;
    },
    runCostDialog() {
      this.run_cost = {};
      this.isRunCost = true;
    },
    viewItem(item) {
      item['_isFrom'] = this.$route.name;
      this.$router.push({ name: 'SalesCostView', params: item });
    },
    async findSalesCosts(){
      this.isFindDialog = false;
      if(Object.keys(this.find_query).length==0){
        await this.getSalesCostsRequest();
        this.data_orders = Object.assign([], this.salescosts);
        this.data_orders.push({salesordertotal: this.salescosts.reduce(function (last, json) {return last + json.salesordertotal;}, 0) });
      }
      else{
        let result = await this.findSalesCostsRequest(this.find_query);
        this.data_orders = Object.assign([], result);
      }
    },
    async resetSalesOrders(){
      this.find_query = {};

    },
    async deleteCost(item) {
      this.isDeleteCost = false;
      let result = await this.deleteSalesCostsRequest(item);
      let index = this.data_orders.findIndex((x) => x._id == result._id);
      this.data_orders.splice(index, 1, result);
    },
    deleteCostDialog(item) {
      this.isDeleteCost = true;
      this.delete_cost = { _id: item._id, salesordernum: item.salesordernum, salesordername: item.salesordername };
    },
    async updateOrderCost(){
      this.isConfirmCost = false;
      let results = await this.updateSalesCostRequest(this.confirm_cost);
      for(var i in results){
        let result = results[i];
        let index = this.data_orders.findIndex((x) => x._id == result._id);
        this.data_orders.splice(index, 1, result);
      }
      this.data_select = [];
      this.confirm_cost = {};
    },
    async runOrderCosts(){
      this.isRunCost = false;
      console.log(this.run_cost)
      let results = await this.runSalesCostRequest(this.run_cost);
      for(var i in results){
        let result = results[i];
        let index = this.data_orders.findIndex((x) => x._id == result._id);
        this.data_orders.splice(index, 1, result);
      }
      this.run_cost = {};
    }
  },
  async created () {
    if(this.$route.params.isDeposit==true) this.data_select = this.$route.params.orders;
    if(this.salescosts.length==0) await this.getSalesCostsRequest();
    this.data_orders = Object.assign([], this.salescosts);

    if(this.locations.length==0) await this.getLocationsRequest();
    if(this.saleschannels.length==0) await this.getSalesChannelsRequest();
    if(this.users.length==0) await this.getUsersRequest();
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
